import { Avatar, Grid, Typography } from "@mui/material";
import { useAuthentication } from "../../../store/Authentication";
import SelectTeamComponent from "./Components/SelectTeam";
import { useState } from "react";
import { ItemNba } from "./Components/Modal";

export default function PinExternal() {
  const { profile } = useAuthentication();
  const[selected, setSelected] = useState<ItemNba | null>(null);
  function handleSelected(item: ItemNba){
    setSelected(item)
  }
  return (
    <Grid
      container
      flexDirection={"column"}
      alignItems={"center"}
      justifyItems={"center"}
      p={4}
      pt={{ md: 10 }}
    >
      <Grid item container width={{ md: "50%", lg: "35%" }} rowSpacing={2}>
        <Grid item container flexDirection={"column"}>
          <Typography variant="h6" align="center">
            Olá, <strong>{profile.nome}</strong>
          </Typography>
          <Typography variant="body1" mt={4}>
            Parece que você já possui um TeamPass ativo, adquirido de uma
            forma externa a nossa plataforma.
          </Typography>
          {/* <Typography variant="body1" mt={1}>
            Para mais informações, entre em contato:
          </Typography>
          <Link href="#">www.epayNBA.com/suporte</Link> */}
          <SelectTeamComponent></SelectTeamComponent>
        </Grid>
      </Grid>
    </Grid>
  );
}
